// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Loading_spinnerContainer__1PL6G","spinner":"Loading_spinner__2jNW3","overlay":"Loading_overlay__fbRpV"};